export enum ConnectorStatuses {
  success = "available",
  danger = "preparing|charging|finishing",
  muted = "disconnected|faulted|stopped|suspendedevse|suspendedev",
}

export enum ConnectorTypes {
  type_1 = "type_1",
  type_2 = "type_2",
  ccs1 = "ccs1",
  ccs2 = "ccs2",
  chademo = "chademo",
  gb_t = "gb_t",
  tesla = "tesla",
  nacs = "nacs",
}

export type ConnectorType = keyof typeof ConnectorTypes;

export type ConnectorDTO = {
  charger_id?: string;
  connector_id: string;
  type: ConnectorType;
  pricing_profile_id: string;
  current_type: CurrentType;
  charging_speed_type: ChargingSpeedType;
  max_charging_speed: number;
};

export type ConnectorForm = {
  id?: string;
  connector_id: string;
  type: string;
  pricing_profile_id: string;
  current_type: string;
  charging_speed_type: string;
  max_charging_speed: string;
};

export enum ChargingSpeedTypes {
  slow = "slow",
  fast = "fast",
  ultra = "ultra",
}

export type ChargingSpeedType = keyof typeof ChargingSpeedTypes;

export enum CurrentTypes {
  AC = "ac",
  DC = "dc",
}

export type CurrentType = keyof typeof CurrentTypes;
